import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiHome, FiMail, FiPhone, FiUser } from "react-icons/fi";
import TextBox from "../../../components/input/TextBox";
import { useContextProvider } from "../../../components/page-context/ContextProvider";
import { TableHeaderContainer } from "../../../components/container/TableHeaderContainer";
import { TableTitleContainer } from "../../../components/container/TableTitleContainer";
import { ReusedProduct } from "../../../db_access/reused_product";
import muiSytle from "../../../style/components-style/muiStyle";

const ReusedProductSupplierInfo = ({ reusedProduct }) => {
  const { t } = useTranslation();
  const { isSaveClicked, setIsSaveVisible, setIsSaveClicked, setIsLoading, setRefresh } = useContextProvider();
  const [modified, setModified] = useState(false);
  const [formData, setFormData] = useState({ detail_address: "", detail_contact_person: "", detail_email: "", detail_phone: "" });
  const formContentLeft = [
    { label: "Contact Person", field: "detail_contact_person", icon: FiUser },
    { label: "Email", field: "detail_email", icon: FiMail },
  ];
  const formContentRight = [
    { label: "Phone number", field: "detail_phone", icon: FiPhone },
    { label: "Address", field: "detail_address", icon: FiHome },
  ];

  useEffect(() => {
    const cleanData = {};
    if (reusedProduct) {
      Object.keys(reusedProduct).forEach((k) => {
        cleanData[k] = (reusedProduct[k] === null || reusedProduct[k] === "null") ? "" : reusedProduct[k];
      });
    }
    setFormData(cleanData);
    setModified(false);
  }, [reusedProduct]);

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
    setIsSaveVisible(true);
    setModified(true);
  };
  const reset = async () => {
    if (formData && formData.id) {
      ReusedProduct.resetSupplierInfo(formData.id).finally(() => {
        setModified(false);
        setIsSaveVisible(false);
        setRefresh((r) => !r);
      });
    }
  };

  useEffect(() => {
    if (isSaveClicked && modified) {
      ReusedProduct.updateSupplierInfo(formData).finally(() => {
        setModified(false);
        setIsSaveClicked(false);
        setIsLoading(false);
        setRefresh((r) => !r);
      });
    }
  }, [isSaveClicked, modified, formData, setIsSaveClicked, setIsLoading, setRefresh]);

  return (
    <Paper variant="Table Container">
      <TableHeaderContainer>
        <TableTitleContainer>
          <Typography variant="Table Title">{t("Supplier Info")}</Typography>
        </TableTitleContainer>
      </TableHeaderContainer>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box sx={{ display: "flex", gap: 1 }} style={{ flex: 1 }}>
            {formContentLeft.map((f, i) => (
              <Box key={i} style={{ flex: 1 }}>
                <TextBox placeholder={f.label} value={formData[f.field]} onChange={handleChange(f.field)} label={f.label} Icon={f.icon} />
              </Box>
            ))}
          </Box>
          <Box sx={{ display: "flex", gap: 1 }} style={{ flex: 1 }}>
            {formContentRight.map((f, i) => (
              <Box key={i} style={{ flex: 1 }}>
                <TextBox placeholder={f.label} value={formData[f.field]} onChange={handleChange(f.field)} label={f.label} Icon={f.icon} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default ReusedProductSupplierInfo;
